import configuration from "@trustpilot/businessapp-configuration";

import { claimPageUrl } from "./constants";

export default {
  ...configuration,
  authorizeTrustpilotApiHosts: "#{AuthorizeTrustpilotApiHosts}",
  simplifiedLayoutPages: [
    "/onboarding/personalization",
    "/onboarding/setup",
    "/onboarding/setup/profile",
    "/onboarding/setup/emailtools",
    "/onboarding/automate",
    claimPageUrl,
  ],
  experimentClientId: "#{ExperimentClientId}",
  salesforceWidgetId: "#{SalesforceWidgetId}",
  salesforceWidgetType: "#{SalesforceWidgetType}",
  salesforceBootstrapUrl: "#{SalesforceBootstrapUrl}",
  salesforceScrt2URL: "#{SalesforceScrt2URL}",
};
